<template>
  <twitterqueries-form :twitter-query="twitterQuery" :available-sources="availableSources"></twitterqueries-form>
</template>

<script>
export default {
  props: ['twitterQuery', 'availableSources']
}
</script>
